import type { ReactNode } from 'react';

const toneMap = {
  online: '#1F8A7A',
  processing: '#38D5FF',
  pending: '#FFCC66',
  failed: '#FF5F56',
  archived: '#60756E',
  offline: '#60756E',
} as const;

export function StatusPill({ status, children }: { status: keyof typeof toneMap; children?: ReactNode }) {
  return <span style={{ fontFamily: '"JetBrains Mono", "IBM Plex Mono", ui-monospace, monospace', fontSize: 11, letterSpacing: '0.08em', textTransform: 'uppercase', borderRadius: 999, border: `1px solid ${toneMap[status]}`, color: toneMap[status], padding: '2px 8px' }}>{children ?? status}</span>;
}
